const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIncisivo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "100%",
    height: "100%",
    viewBox: "0 0 300 300",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "incisor-group"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 75,
    stroke: "black",
    id: "incisal",
    style: {
      strokewidth: 5
    },
    width: 150,
    height: 150,
    fill: "white"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "black",
    id: "buccal",
    style: {
      strokewidth: 5
    },
    points: "0 0 300 0 225 112.5 75 112.5",
    fill: "white"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "black",
    id: "mesial",
    style: {
      strokewidth: 5
    },
    points: "300 0 300 300 225 187.5 226 112.5",
    fill: "white"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "black",
    id: "palatal",
    style: {
      strokewidth: 5
    },
    points: "300 300 0 300 75 187.5 225 187.5",
    fill: "white"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "black",
    id: "distal",
    style: {
      strokewidth: 5
    },
    points: "0 300 0 0 75 112.5 75 187.5",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncisivo);
export default __webpack_public_path__ + "static/media/incisivo.ac70b02990e4f2a6b8c0e2d77064af09.svg";
export { ForwardRef as ReactComponent };